export default __webpack_public_path__ + "static/media/011-speedometer.9cb282b1.svg";